import {typographyStyles, constants} from '@newsela/angelou';
import {css} from 'emotion';

import {gradientBackgrounds, partialCtaDefaultLinearGradientBackground} from '../AISearchMenuContainer.styles.js';

const {colors} = constants;
const {ui, status} = colors;
const {textMObj, textSObj, textXSObj} = typographyStyles;
const {fontSize} = textMObj;


export const rootContainerCss = (
  expanded,
  isMobile = false,
) => css({
  position: 'relative',
  width: '270px',

  ...(expanded
    ? {
        ...(isMobile
          ? {
              width: 'inherit',
              height: 0,
            }
          : {}),
      }
    : {}),
});

export const innerBorderCss = (
  expanded,
  isMobile = false,
) => css({
  position: 'relative',
  padding: '1px',
  borderRadius: '10px',
  backgroundImage:
    'linear-gradient(279.44deg, #691C9C 4.6%, #1F3CD7 66.61%, #1088EB 100%)',
  backgroundOrigin: 'border-box',
  transition: 'transform 0.5s ease',

  ...(expanded
    ? {
        width: '480px',
        zIndex: 100,
        top: isMobile ? 64 : 130,
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        transform: 'translate(0.5%, 0) scale(1)',

        ...(isMobile
          ? {
              width: 'inherit',
              borderRadius: '0 0 10px 10px',
              transform: 'none',
            }
          : {}),
      }
    : {}),
});

export const innerContentCss = (expanded) => css({
  position: 'relative',
  background: gradientBackgrounds[100],
  borderRadius: 'inherit',
  padding: expanded ? '12px' : '2px 6px',
  display: 'flex',
  flex: 1,
  flexDirection: expanded ? 'column' : 'row',
  justifyContent: 'flex-start',
  alignItems: expanded ? 'stretch' : 'center',
  gap: expanded ? 12 : 0,
  width: '100%',

  // Adds full width to all its immediate child divs
  // so they can all be aligned equally. The toggle
  // with track event also prevents us from styling
  // the root div so this also solves for that.
  '> div': {
    width: '100%',
  },
});

export const headingSectionExpandedCss = css({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 4,
  padding: '4px 0',
});

export const textAreaRootContainerCss = (
  expanded,
  isCharLimitReached,
) => css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  ...(expanded
    ? {
        width: '100%',
        // The following styles create the border around the textarea.
        // To achieve a gradient as a 'border', we apply it as a background
        // and adjust padding and radius on here and on the textarea.
        borderRadius: '6px',
        padding: '2px',
        ...(isCharLimitReached
          ? {background: status.danger[600]}
          : partialCtaDefaultLinearGradientBackground),
      }
    : {}),
});

export const labelTextCss = css({
  width: 0,
  height: 0,
  margin: 0,
  overflow: 'hidden',
});

export const textAreaCss = (expanded) => css({
  fontFamily: 'Circular,Helvetica,Arial,sans-serif',
  fontSize,
  color: ui.neutral[700],
  whiteSpace: expanded ? 'normal' : 'nowrap',
  resize: 'none',
  width: '220px',
  borderRadius: '5px',
  overflow: 'hidden',
  border: 'none',
  padding: '10px 1px',
  ...(!expanded && {paddingLeft: '4px'}),
  transition: 'minWidth 0.5s ease',

  ...(expanded
    ? {
        width: '100%',
        borderRadius: '4px',
        padding: '10px',
      }
    : {}),

  ':hover': {
    border: 'none',
  },
  ':focus-visible': {
    outline: 'none',
  },
  '::placeholder': {
    paddingLeft: '6px',
    color: ui.neutral[500],
  },
});

export const svgCss = {
  width: '36px',
  height: '34px',
};

export const toggleSwitchContainerCss = {
  ...partialCtaDefaultLinearGradientBackground,
};

export const footerSectionCss = css({
  // This margin top is overriding the fact that
  // the error state message is on the DOM but hidden,
  // to prevent elements jumping, so this adjusts
  // the spacing between the footer elements and textarea.
  marginTop: '-18px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const charLimitSlotCss = (isCharLimitReached) => css({
  minHeight: 20,
  display: 'flex',
  alignItems: 'center',
  ...(isCharLimitReached
    ? {
        opacity: 1,
        visibility: 'visible',
      }
    : {
        opacity: 0,
        visibility: 'hidden',
        pointerEvents: 'none',
      }),
});

export const charLimitContainerCss = css({
  marginTop: '-12px',
  display: 'flex',
  alignItems: 'center',
});

export const charLimitIconCss = {
  width: '20px',
  path: {
    fill: status.danger[600],
    stroke: ui.white[700],
  },
};

export const charLimitInfoCss = css({
  fontFamily: 'Circular,Helvetica,Arial,sans-serif',
  fontSize: textXSObj.fontSize,
  color: status.danger[600],
});

export const charLimitCss = (isCharLimitReached) => css({
  fontSize: textSObj.fontSize,
  color: isCharLimitReached ? status.danger[600] : ui.neutral[700],
});
